import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/AdministrationCompany/AdministrationCompanyModel';
import { RootState } from '../../../store';
import AdministrationCompanyForm from '../AdministrationCompanyForm/AdministrationCompanyForm';

const AdministrationCompanyModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxCompany = useSelector((state: RootState) => state.models.administrationCompany);

  return (
    <Modal
      title={!!reduxCompany.id ? 'Modifica' : 'Adauga'}
      open={reduxCompany.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <AdministrationCompanyForm />
    </Modal>
  );
};

export default AdministrationCompanyModal;
